import { Users } from '@just-in-types';
import { combineReducers, Reducer } from 'redux';
import camera, { ICameraState } from './cameraReducer';
import router, { IRouterState } from './routerReducer';
import telemetry, { ITelemetryState } from './telemetryReducer';
import theme, { ThemeState } from './themeReducer';
import user from './userReducer';
import userTemp, { IUserTempState } from './userTempReducer';

export interface IState {
  camera: ICameraState;
  router: IRouterState;
  telemetry: ITelemetryState;
  theme: ThemeState;
  user: Users.User;
  userTemp: IUserTempState;
}

const rootReducer: Reducer<IState> = combineReducers({
  camera,
  router,
  telemetry,
  theme,
  user,
  userTemp,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.ts